import GetIcon from "Components/Global/Icons";

import SectionLoading from "./Components/Loading";
import * as S from "./styles";

import { useTheme } from "styled-components";

const Section = ({
  noBackground,
  noPadding,
  bottom,
  children,
  head = {},
  loading,
}) => {
  const theme = useTheme();
  const haveHead = Object.keys(head).length;

  return (
    <S.Wrapper
      bottom={bottom}
      haveHead={haveHead}
      noBackground={noBackground}
      noPadding={noPadding}
    >
      {loading && <SectionLoading />}
      {haveHead ? (
        <S.Head>
          <GetIcon name={head.icon} color={theme.colors.primary.cetaceanBlue} />
          {head.title && <p>{head.title}</p>}
        </S.Head>
      ) : (
        <></>
      )}
      <S.Content haveHead={haveHead} noPadding={noPadding}>
        {children}
      </S.Content>
    </S.Wrapper>
  );
};

export default Section;
